export function cleanDescription(desc: string): string {
  const marker = " in 20";
  const idx = desc.indexOf(marker);
  if (idx === -1) return desc;
  return desc.slice(0, idx).trim();
}
